<div class="section-card">
  <div
    class="section-header mb-3 d-flex align-items-center justify-content-between"
  >
    <h4 class="section-title">Order Details</h4>
    <!-- <button class="btn-icon-primary bg-white" aria-label="Copy details">
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.375 18.7497C8.80208 18.7497 8.31163 18.5457 7.90365 18.1377C7.49566 17.7297 7.29167 17.2393 7.29167 16.6663V4.16634C7.29167 3.59342 7.49566 3.10297 7.90365 2.69499C8.31163 2.287 8.80208 2.08301 9.375 2.08301H18.75C19.3229 2.08301 19.8134 2.287 20.2214 2.69499C20.6293 3.10297 20.8333 3.59342 20.8333 4.16634V16.6663C20.8333 17.2393 20.6293 17.7297 20.2214 18.1377C19.8134 18.5457 19.3229 18.7497 18.75 18.7497H9.375ZM5.20833 22.9163C4.63542 22.9163 4.14497 22.7123 3.73698 22.3044C3.32899 21.8964 3.125 21.4059 3.125 20.833V6.24967H5.20833V20.833H16.6667V22.9163H5.20833Z"
          fill="#004B64"
        />
      </svg>
    </button> -->
  </div>
  <div class="order-type-card">
    <div class="order-type-content d-flex align-items-center">
      <img
        class="rounded-md"
        src="assets/images/order-detail-full-load.png"
        alt="images"
      />
      <div>
        <h6 class="text-subtitle1">{{ orderType[orderDetails.type] }}</h6>
        <p class="update-time">
          Last update {{ orderDetails.updatedAt | date : 'HH:mm ddMMM yyyy' }}
        </p>
      </div>
    </div>
  </div>
  <div class="info-grid">
    <div class="info-item">
      <p class="info-label">Total Weight</p>
      <p class="info-value">{{ orderDetails.totals.totalWeight }}KG</p>
    </div>
    <div class="info-item">
      <p class="info-label">Order date &amp; time</p>
      <p class="info-value">
        {{ orderDetails.createdAt | date : 'HH:mm ddMMM yyyy' }}
      </p>
    </div>
  </div>
  <div class="info-grid">
    <div class="info-item">
      <p class="info-label">Order created by</p>
      <p class="info-value">{{ orderDetails?.orderByName }}</p>
    </div>
    <div class="info-item">
      <p class="info-label">Order status</p>
      <p
        class="info-value success-text order-status-{{
          orderDetails?.state.code
        }}"
      >
        {{ orderDetails?.state.label }}
      </p>
    </div>
  </div>

  <div class="info-grid">
    <div class="info-item">
      <p class="info-label">Order Weight</p>
      <p class="info-value">{{ orderDetails?.totals?.totalWeight }} KG</p>
    </div>
    <div class="info-item">
      <p class="info-label">Actual Weight</p>
      <p class="info-value">{{ orderDetails?.totals?.actualWeight }} KG</p>
    </div>
  </div>
</div>
<hr class="divider" />
